module.exports = __webpack_public_path__ + "static/fonts/iconfont.07edcf41.woff2";